import { createSelector } from 'reselect';


/**
* Список id голосований, отфильтрованный, если надо и отсортированный
* @param {bool} isOwn -- только свои голосования
*/
export const getPollsKeys = createSelector(
  (state, isOwn) => {
    const { keys, data } = state.fund.polls;
    const draft = [];
    const new0 = [];
    const active = [];
    const ended = [];
    keys.forEach((key) => {
      switch (data[key].status) {
        case 'draft': {
          draft.push(key);
          break;
        }
        case 'new': {
          new0.push(key);
          break;
        }
        case 'active':
        case 'paused':
        case 'edited': {
          active.push(key);
          break;
        }
        default: {
          ended.push(key);
        }
      }
    });
    return (isOwn
      ? [...ended, ...active, ...new0, ...draft].reverse().filter(id => data[id].isOwner)
      : [...ended, ...active, ...new0, ...draft].reverse()
    );
  },
  items => items
);

/**
* Статистика голосований
* @param {bool} isOwn -- только для своих
*/
export const getStats = createSelector(
  (state, isOwn) => {
    const { data, keys } = state.fund.polls;
    const stats = {};
    keys.forEach((key) => {
      if (isOwn && !data[key].isOwner) return;
      const statusName = data[key].status;
      stats[statusName] = stats[statusName] ? stats[statusName] += 1 : 1;
      stats.count = stats.count ? stats.count += 1 : 1;
    });
    return stats;
  },
  stats => stats
);
